
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4M98y", function(module, exports) {
/* ContentTreeSearchBase.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yg9g = parcelRequire("4yg9g");


var $hAgam = parcelRequire("hAgam");


var $9GVkD = parcelRequire("9GVkD");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $l3wuH = parcelRequire("l3wuH");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $luv00 = parcelRequire("luv00");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $95rLf = parcelRequire("95rLf");


var $fG32j = parcelRequire("fG32j");


var $882Qs = parcelRequire("882Qs");


var $5oz05 = parcelRequire("5oz05");

/* LoadingOverlay.tsx generated by @compiled/babel-plugin v0.40.0 */ 








const $1948eb67f5de7483$var$styles = {
    overlayCSS: "_1bsb1osq _4t3i1osq",
    overlayLoading: "_tzy4n2vs _lcxvglyw _80om13gf"
};
const $1948eb67f5de7483$export$3fb99980b01d36b1 = ({ loading: loading, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1948eb67f5de7483$var$styles.overlayCSS, loading && $1948eb67f5de7483$var$styles.overlayLoading),
        "data-vc": "content-tree-search-overlay"
    }, children);


/* ContentSearchResultList.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $dinVW = parcelRequire("dinVW");

/* ContentSearchResultItem.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $hBYtq = parcelRequire("hBYtq");





var $4aRua = parcelRequire("4aRua");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $4K4h4 = parcelRequire("4K4h4");


var $6bZDi = parcelRequire("6bZDi");

const $66703f44eeeed45a$var$styles = {
    pressable: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _2rko12b0 _bfhksm61 _syazazsu _o5721q9c _1bto1l2s _jomr1dpa _irr31dpa _1di6fcek",
    searchResultRow: "_18zru2gc _1rjc12x7",
    title: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1wug _o5721q9c _1bto1l2s _1ul9idpf _y3gn1e5h",
    emojiWrapper: "_1bah1h6o _1o9zidpf _4cvr1h6o _2hwxu2gc",
    contentIconWrapper: "_1e0c1txw _1bah1h6o _4cvr1h6o _1o9zidpf _2hwxu2gc"
};
const $66703f44eeeed45a$var$EmojiWrapper = ({ children: children })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        as: "span",
        xcss: $66703f44eeeed45a$var$styles.emojiWrapper
    }, children);
}; // Icon component that handles both content tree icons and emojis
const $66703f44eeeed45a$var$EmojiOrContentIcon = ({ isContentTreeIconVisible: isContentTreeIconVisible, contentType: contentType, iconColor: iconColor, displayEmoji: displayEmoji })=>{
    if (displayEmoji && (0, $2JGYp.isValidEmojiOrFavicon)(displayEmoji, contentType)) return /*#__PURE__*/ $cozmU.createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: displayEmoji,
        height: 16,
        context: "spaceViews",
        wrapper: $66703f44eeeed45a$var$EmojiWrapper,
        contentType: contentType
    });
    else if (isContentTreeIconVisible) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $66703f44eeeed45a$var$styles.contentIconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4K4h4.ContentTreeIconLoader), {
        type: contentType,
        label: "",
        color: iconColor
    }));
    else return null;
};
const $66703f44eeeed45a$export$e64d3b41d9a5e8b = ({ index: index, title: title, item: item, onItemClick: onItemClick, isCurrentPage: isCurrentPage, displayEmoji: displayEmoji })=>{
    const contentType = item.type || 'page';
    const isContentTreeIconVisible = contentType && (0, $6bZDi.includesValidContentTreeType)(contentType);
    const isLiveDoc = contentType === 'page' && item.subType === 'live';
    const iconContentType = isLiveDoc ? 'liveDoc' : contentType;
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $66703f44eeeed45a$var$styles.pressable,
        onClick: ()=>onItemClick?.(item.id, index),
        testId: "content-search-result-item",
        role: "listitem"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $66703f44eeeed45a$var$styles.searchResultRow,
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement($66703f44eeeed45a$var$EmojiOrContentIcon, {
        isContentTreeIconVisible: !!isContentTreeIconVisible,
        contentType: iconContentType,
        displayEmoji: displayEmoji
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $66703f44eeeed45a$var$styles.title
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, title))));
};


const $f54e5729e0747951$var$getContentIdFromSearchResultId = (id, type)=>{
    if ((type === 'database' || type === 'embed') && id) return id.split('/').pop() || null;
    return id;
};
const $f54e5729e0747951$export$6ca6b02302564a48 = ({ pagesList: pagesList, onItemClick: onItemClick, contentId: contentId })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        testId: "content-search-result-list",
        role: "list"
    }, pagesList.map(({ title: title, id: id, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, displayEmoji: displayEmoji, type: type, subType: subType }, index)=>{
        const isCurrentPage = Boolean(contentId && contentId === id);
        const parsedId = $f54e5729e0747951$var$getContentIdFromSearchResultId(id, type);
        const item = {
            id: parsedId || '',
            hasRestrictions: hasRestrictions,
            hasInheritedRestrictions: hasInheritedRestrictions,
            type: type,
            subType: subType
        };
        return /*#__PURE__*/ $cozmU.createElement((0, $66703f44eeeed45a$export$e64d3b41d9a5e8b), {
            key: id,
            index: index,
            title: title || '',
            item: item,
            onItemClick: onItemClick,
            isCurrentPage: isCurrentPage,
            displayEmoji: displayEmoji
        });
    }));
};


const $21121a6cfbacc686$var$styles = {
    pageTreeContainer: "_18m91wug _c71l1178 _18u0r5cr",
    dialogContainer: "_4t3i1178",
    searchResultContainer: "_19bv1b66 _syazazsu",
    searchIconBefore: "_19bvu2gc",
    searchTextfield: "_1mouu2gc",
    textfieldContainer: "_2rko12b0 _189ee4h9 _1h6d1l7x",
    emptyResultsContainer: "_4t3i1osq"
};
const $21121a6cfbacc686$export$5bfab88ca340829a = ({ children: children, spaceKey: spaceKey, contentId: contentId, onItemClick: onItemClick, isModernizedDialog: isModernizedDialog, placeholder: placeholder, includeFolders: includeFolders })=>{
    const [searchText, setSearchText] = (0, $cozmU.useState)('');
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const intl = (0, $kSwu1.useIntl)();
    const inputRef = (0, $cozmU.useRef)(null);
    const { searchResult: searchResult, loading: loading, error: error } = (0, $5oz05.useContentTreeSearch)(searchText, 'moveDialog', spaceKey, includeFolders);
    const handleChange = (e)=>{
        const inputValue = e.currentTarget.value || '';
        setSearchText(inputValue);
    };
    const onSearchResultClick = (id, index)=>{
        onItemClick(id, index);
        setSearchText('');
    };
    const renderPageTreeOrSearchResults = ()=>{
        if (error) {
            if ((0, $fG32j.isSpaceRestrictedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) // Mark error as handled since we're displaying a user-friendly error message
            (0, $7Sm4c.markErrorAsHandled)(error);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $882Qs.ContentTreeSearchErrorLoader), null));
        }
        if (searchResult && searchResult.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $882Qs.ContentTreeSearchEmptyLoader), null);
        if (!searchResult) return children;
        if (searchResult.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $21121a6cfbacc686$var$styles.searchResultContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$21121a6cfbacc686$var$i18n.searchResultsCount,
            values: {
                count: searchResult.length
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f54e5729e0747951$export$6ca6b02302564a48), {
            pagesList: searchResult,
            spaceKey: spaceKey,
            contentId: contentId,
            onItemClick: onSearchResultClick
        }));
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-vc": "content-tree-search",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: "contentTreeSearch",
        xcss: $21121a6cfbacc686$var$styles.searchTextfield
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        ref: inputRef,
        "aria-label": intl.formatMessage($21121a6cfbacc686$var$i18n.searchLabel),
        "aria-describedby": "contentTreeSearchInfo",
        placeholder: placeholder ?? intl.formatMessage($21121a6cfbacc686$var$i18n.searchLabel),
        onChange: handleChange,
        value: searchText,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $21121a6cfbacc686$var$styles.searchIconBefore,
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })),
        elemAfterInput: searchText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            shape: "circle",
            label: intl.formatMessage($21121a6cfbacc686$var$i18n.clearSearch),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    label: "",
                    size: "small",
                    color: "var(--ds-icon, #292A2E)"
                }),
            onClick: ()=>setSearchText('')
        }) : null,
        isCompact: true,
        testId: "content-tree-search-input",
        className: (0, $hekY6.default)([
            $21121a6cfbacc686$var$styles.textfieldContainer
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: "contentTreeSearchInfo"
    }, intl.formatMessage($21121a6cfbacc686$var$i18n.searchInputDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1948eb67f5de7483$export$3fb99980b01d36b1), {
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($21121a6cfbacc686$var$styles.pageTreeContainer, isModernizedDialog && $21121a6cfbacc686$var$styles.dialogContainer)
    }, renderPageTreeOrSearchResults())));
};
const $21121a6cfbacc686$var$i18n = (0, $kSwu1.defineMessages)({
    searchLabel: {
        id: "content-tree-search.placeholder",
        defaultMessage: "Search by title"
    },
    clearSearch: {
        id: "content-tree-search.clear-search",
        defaultMessage: "Clear search"
    },
    searchInputDescription: {
        id: "content-tree-search.input-description",
        defaultMessage: "Results will update as you type."
    },
    searchResultsCount: {
        id: "content-tree-search.results-count",
        defaultMessage: "{count} {count, plural, one {result} other {results}} found"
    }
});
module.exports["ContentTreeSearchBase"] = $21121a6cfbacc686$export$5bfab88ca340829a;

});

parcelRegister("882Qs", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e664998f36f6457c$export$1c108e9c11520cac = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "BwMOJ",
    name: "ContentTreeSearchEmptyLoader",
    loader: async ()=>(await (parcelRequire("hn0lz"))).ContentTreeSearchEmpty
});

const $e664998f36f6457c$export$f3cc49687d3dd9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KEbqE",
    name: "ContentTreeSearchErrorLoader",
    loader: async ()=>(await (parcelRequire("hn0lz"))).ContentTreeSearchError
});
module.exports["ContentTreeSearchEmptyLoader"] = $e664998f36f6457c$export$1c108e9c11520cac;
module.exports["ContentTreeSearchErrorLoader"] = $e664998f36f6457c$export$f3cc49687d3dd9d7;

});

parcelRegister("hn0lz", function(module, exports) {

let $ca54da8c9f2546b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca54da8c9f2546b2$var$load("6FaFk").then(()=>parcelRequire('wyyi4'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("5oz05", function(module, exports) {
/**
 * @generated SignedSource<<c2112c9726c360c6af2f5f22561c8af6>>
 * @relayHash 83fe03e4bf3c53079ba8fc5909b9c487
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e803913c940138899e1c84749aac24260f42d50e667a0fe0dedcbfb86e618092
const $e8ae638795b2b78e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchText"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchText"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "concreteType": "ConfluenceContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceContentTitleEmoji",
                        "kind": "LinkedField",
                        "name": "titleEmojiPublished",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ConfluencePage"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentTreeSearchContentTreeSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentTreeSearchContentTreeSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v5 /*: any*/ 
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "83fe03e4bf3c53079ba8fc5909b9c487",
            "id": "e803913c940138899e1c84749aac24260f42d50e667a0fe0dedcbfb86e618092",
            "metadata": {},
            "name": "useContentTreeSearchContentTreeSearchQuery",
            "operationKind": "query",
            "text": "query useContentTreeSearchContentTreeSearchQuery($experience:String!,$searchText:String!,$first:Int,$filters:SearchFilterInput!){search{search(experience:$experience,query:$searchText,first:$first,filters:$filters){edges{node{__typename,id,title,type,...on SearchConfluencePageBlogAttachment{entityId,confluenceEntity{__typename,...on ConfluencePage{id,subtype,metadata{titleEmojiPublished{id,value}}},...on Node{__isNode:__typename,id}}}}}}}}"
        }
    };
}();
$e8ae638795b2b78e$var$node.hash = "95d3c3eee93e0115b50c32fd07cd47e2";
var $e8ae638795b2b78e$export$2e2bcd8739ae039 = $e8ae638795b2b78e$var$node;



var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $56QzY = parcelRequire("56QzY");

/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $748ce020ea1d386c$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $748ce020ea1d386c$export$77cdd20d47be2a2f = /*#__PURE__*/ function(SearchCombinationType) {
    SearchCombinationType["AND"] = "AND";
    SearchCombinationType["OR"] = "OR";
    return SearchCombinationType;
}({});
var $748ce020ea1d386c$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["CURRENT"] = "CURRENT";
    SearchConfluenceDocumentStatus["ARCHIVED"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["DRAFT"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({});
var $748ce020ea1d386c$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchConfluenceRangeField["CREATED"] = "CREATED";
    return SearchConfluenceRangeField;
}({});
var $748ce020ea1d386c$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["ARCHIVED"] = "ARCHIVED";
    SearchContainerStatus["CURRENT"] = "CURRENT";
    return SearchContainerStatus;
}({});
var $748ce020ea1d386c$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["OPEN"] = "OPEN";
    SearchIssueStatusCategory["DONE"] = "DONE";
    return SearchIssueStatusCategory;
}({});
var $748ce020ea1d386c$export$f83401feaa563e1e = /*#__PURE__*/ function(SearchLinkedEntityGranularity) {
    SearchLinkedEntityGranularity["FULL_THREAD"] = "FULL_THREAD";
    SearchLinkedEntityGranularity["ALL_MATCHING_MESSAGES"] = "ALL_MATCHING_MESSAGES";
    SearchLinkedEntityGranularity["DEFAULT"] = "DEFAULT";
    return SearchLinkedEntityGranularity;
}({});
var $748ce020ea1d386c$export$45f36aeb819dbce5 = /*#__PURE__*/ function(SearchParticipantType) {
    SearchParticipantType["MENTIONS"] = "MENTIONS";
    SearchParticipantType["CONTRIBUTOR"] = "CONTRIBUTOR";
    SearchParticipantType["PRESENCE"] = "PRESENCE";
    return SearchParticipantType;
}({});
var $748ce020ea1d386c$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["software"] = "software";
    SearchProjectType["business"] = "business";
    SearchProjectType["service_desk"] = "service_desk";
    SearchProjectType["product_discovery"] = "product_discovery";
    return SearchProjectType;
}({});
var $748ce020ea1d386c$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["database"] = "database";
    SearchResultType["whiteboard"] = "whiteboard";
    SearchResultType["embed"] = "embed";
    SearchResultType["folder"] = "folder";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["dashboard"] = "dashboard";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["goal"] = "goal";
    SearchResultType["project_update"] = "project_update";
    SearchResultType["goal_update"] = "goal_update";
    SearchResultType["tag"] = "tag";
    SearchResultType["focus_area"] = "focus_area";
    SearchResultType["focus_area_status_update"] = "focus_area_status_update";
    SearchResultType["ask"] = "ask";
    SearchResultType["question"] = "question";
    SearchResultType["learning"] = "learning";
    SearchResultType["document"] = "document";
    SearchResultType["repository"] = "repository";
    SearchResultType["component"] = "component";
    SearchResultType["presentation"] = "presentation";
    SearchResultType["spreadsheet"] = "spreadsheet";
    SearchResultType["message"] = "message";
    SearchResultType["object_schema"] = "object_schema";
    SearchResultType["object_type"] = "object_type";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $748ce020ea1d386c$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchThirdPartyRangeField["CREATED"] = "CREATED";
    return SearchThirdPartyRangeField;
}({})// Note: Original file contained additional custom exports that need manual review:
// SearchAssetsFilter, SearchAssetsObjectSchemaFilter, SearchAssetsObjectTypeFilter, SearchBoardFilter, SearchCommonFilter, SearchCommonRangeFilter, SearchCommonRangeFilterFields, SearchCompassComponentFilter, SearchCompassFilter, SearchConfluenceFilter, SearchConfluenceRangeFilter, SearchExternalContainerFilter, SearchExternalContentFormatFilter, SearchExternalDepthFilter, SearchExternalFilter, SearchFilterInput, SearchJiraFilter, SearchJiraIssueFilter, SearchJiraProjectFilter, SearchMercuryFilter, SearchParticipant, SearchParticipants, SearchThirdPartyFilter, SearchThirdPartyProduct, SearchThirdPartyRangeFilter, SearchTrelloFilter
// Please verify these are handled correctly in your codebase.
;


const $a306f397805d802c$var$SEARCH_PAGE_SIZE = 50;
const $a306f397805d802c$var$CONTENT_TREE_SEARCH_ENTITY_ATIS = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:slide'
];
const $a306f397805d802c$var$CONTENT_TREE_SEARCH_ENTITY_ATIS_WITH_FOLDERS = [
    ...$a306f397805d802c$var$CONTENT_TREE_SEARCH_ENTITY_ATIS,
    'ati:cloud:confluence:folder'
];
const $a306f397805d802c$var$isFolderEntityId = (id)=>typeof id === 'string' && id.includes(':folder/');
const $a306f397805d802c$var$getSearchResultType = ({ id: id, entityId: entityId, type: type, confluenceEntity: confluenceEntity })=>{
    if (confluenceEntity?.__typename === 'ConfluenceFolder' || $a306f397805d802c$var$isFolderEntityId(entityId) || $a306f397805d802c$var$isFolderEntityId(id)) return 'folder';
    return type;
};
const $a306f397805d802c$var$transformSearchData = (data)=>{
    const nodes = data?.search?.search?.edges?.map((edge)=>edge.node) || undefined;
    return nodes?.map(({ id: id, entityId: entityId, title: title, type: type, confluenceEntity: confluenceEntity })=>({
            id: entityId,
            title: title,
            displayEmoji: confluenceEntity?.metadata?.titleEmojiPublished?.value,
            type: $a306f397805d802c$var$getSearchResultType({
                id: id,
                entityId: entityId,
                type: type,
                confluenceEntity: confluenceEntity
            }),
            subType: confluenceEntity?.subtype?.toLowerCase() ?? '',
            // TODO: Show super admins which pages are restricted -- this info is not yet available in AGG
            hasRestrictions: false,
            hasInheritedRestrictions: false
        }));
};
const $a306f397805d802c$export$701bedbfad07b1e = (searchText, source, spaceKey, includeFolders = false)=>{
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const resolvedSpaceKey = spaceKey ?? pageSpaceKey; // Use provided spaceKey or fall back to context
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(resolvedSpaceKey);
    const entities = includeFolders ? $a306f397805d802c$var$CONTENT_TREE_SEARCH_ENTITY_ATIS_WITH_FOLDERS : $a306f397805d802c$var$CONTENT_TREE_SEARCH_ENTITY_ATIS;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $e8ae638795b2b78e$export$2e2bcd8739ae039), {
        variables: {
            searchText: searchText,
            experience: 'confluence.searchInTree',
            first: $a306f397805d802c$var$SEARCH_PAGE_SIZE,
            filters: {
                entities: entities,
                locations: [
                    'ari:cloud:confluence::site/'.concat(cloudId)
                ],
                confluenceFilters: {
                    spacesFilter: resolvedSpaceKey ? [
                        resolvedSpaceKey
                    ] : undefined,
                    contentStatuses: [
                        (0, $748ce020ea1d386c$export$75fb70288e44d634).CURRENT
                    ],
                    titleMatchOnly: true
                }
            }
        },
        interopApolloAggClient: true,
        skip: searchText.length === 0,
        __callerPackage__: "content-tree-search"
    });
    const searchResult = (0, $cozmU.useMemo)(()=>$a306f397805d802c$var$transformSearchData(data), [
        data
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (searchResult) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'searched',
                actionSubject: 'contentTree',
                source: source,
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    searchResultCount: searchResult.length,
                    navdexPointType: (0, $56QzY.TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        searchResult,
        spaceId,
        source
    ]);
    return {
        searchResult: searchResult,
        loading: loading,
        error: error
    };
};
module.exports["useContentTreeSearch"] = $a306f397805d802c$export$701bedbfad07b1e;

});


//# sourceMappingURL=MovePageDialog.4cda7efe.js.map
